import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// @MUI Components
import { Grid, Box, Button, FormControlLabel, Switch } from '@mui/material';

// @Icons
import AddIcon from '@mui/icons-material/Add';

// @Components
import { SearchField } from '../../../components';
import i18n from '../../../i18n';

// @Interfaces and Types
interface IProps {
  filter: string;
  handleFilter: (value: string) => void;
  check: boolean;
  handleCheck: () => void;
  canAdd: any;
}

export default function Actions({ filter, handleFilter, check, handleCheck, canAdd = false }: IProps) {
  const { t } = useTranslation('common');
  const navigate = useNavigate();

  return (
    <Grid
      container
      sx={{
        mb: 5,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'nowrap',
        gap: 2,
        flexDirection: { xs: 'row', md: 'row' },
      }}
    >
      <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center', gap: 2, minWidth: 0 }}>
        <SearchField value={filter} handleFilter={handleFilter} placeholder={t('general.search', { ns: 'common' })} />

        <FormControlLabel
          control={<Switch checked={check} onChange={handleCheck} />}
          label={t('general.status', { ns: 'common' })}
          sx={{ whiteSpace: 'nowrap' }}
        />
      </Box>

      {Boolean(canAdd) && (
        <Button
          size='large'
          variant='contained'
          onClick={() => navigate('/suppliers/create')}
          sx={{
            flexShrink: 0,
            minWidth: { xs: 'auto', md: 'unset' },
            px: { xs: 1, md: 2 },
          }}
        >
          <AddIcon />
          <Box component='span' sx={{ display: { xs: 'none', md: 'inline' } }}>
            {i18n.language === 'es' ? canAdd.ESname : canAdd.name}
          </Box>
        </Button>
      )}
    </Grid>
  );
}
